import useRequestState from "@hooks/useRequestState";
import { useCallback } from "react";
import forgotPassword from "../forgotPassword";

const useForgotPassword = (email?: string) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<null>(null);

  const send = useCallback(async () => {
    if (email == null) {
      return setError("Email and code are required");
    }

    setLoading();
    try {
      await forgotPassword(email);
      return setSuccess(null);
    } catch (err: any) {
      return setError(err.message);
    }
  }, [email, setError, setLoading, setSuccess]);

  return { ...reqState, data: reqState.data, send };
};

export default useForgotPassword;
